/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC, ReactElement } from 'react'
import search from '../../assets/icons/search.svg'
import Input from '../input'

type SearchBarProps = {
  label: string;
  value?: string;
  onChange?: {
    (e: React.ChangeEvent<any>): void;
    <T_1 = string | React.ChangeEvent<any>>(field: T_1): T_1 extends React.ChangeEvent<any> ? void : (e: string | React.ChangeEvent<any>) => void;
  };
}

const SearchBar: FC<SearchBarProps> = ({ label, value, onChange }): ReactElement => {
  return (
    <Input
      label={label}
      value={value}
      onChange={onChange}
      rightAttachment={
        <img width={24} style={{ marginRight: 23 }} alt='search' src={search} />
      }
    />
  )
}

export default SearchBar
